import { isPlatformBrowser, NgFor, NgIf } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { AllDepartmentsData } from '@models/departments.model';
import { TranslateModule } from '@ngx-translate/core';
import { DepartmentService } from '@services/department.service';
import { take } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-all-departments',
  templateUrl: './all-departments.component.html',
  styleUrls: ['./all-departments.component.scss'],
  standalone: true,
  imports: [RouterLink, TranslateModule, MatFormFieldModule, NgIf, NgFor, MatProgressSpinnerModule, MatDividerModule, MatInputModule]
})
export class AllDepartmentsComponent implements OnInit {

  private defaultStore = environment.defaultStore;
  public departments: AllDepartmentsData[] = [];
  public loading = true;
  public isBrowser: boolean;
  constructor(
    private departmentService: DepartmentService,
    @Inject(PLATFORM_ID) private platformId: string,

  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.getDepartments();
  }

  private getDepartments(): void {
    if (this.isBrowser) {
      this.loading = true;
      const storeId = JSON.parse(localStorage.getItem('address') || '{}').store;
      this.departmentService.getAllDepartments(storeId ?? this.defaultStore).pipe(take(1)).subscribe(({
        next: ({ data }) => {
          this.departments = data.map((department: AllDepartmentsData) => {
            const nameArr = department.description.split(' ');
            const desc = nameArr.join('-');
            department.department_url = `${desc.toLowerCase()}-${department.department_id}`;
            return department;
          });
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      }));
    }
  }
}
